import { Navigate } from 'react-router-dom';
import App from './App';

function AppWrapper() {
    if (!(window.localStorage.getItem('user'))) return <Navigate replace to='/signin' />

    return <App />
}

export default AppWrapper;